<template>
  <div
    class="cta-box"
    :class="[slim && 'cta-box--slim', clickable && 'cta-box--clickable']"
    @click="clickable && $emit('click')"
  >
    <div class="cta-box__icon" :class="disabled && 'cta-box__icon--disabled'">
      <slot v-if="!disabled" name="icon" />
      <slot v-else name="icon-disabled">
        <IconLock aria-hidden="true" />
      </slot>
    </div>
    <div class="cta-box__right" :class="!clickable && 'cta-box__right--wrapped'">
      <div class="cta-box__text">
        <p>{{ title }}</p>
        <p>{{ subtitle }}</p>
      </div>
      <IconChevronRight v-if="clickable" aria-hidden="true" />
      <ElTooltip v-else-if="disabled && disabledTooltip" :content="disabledTooltip" placement="top" :teleported="false">
        <span>
          <Button :label="buttonLabel" :disabled="true" />
        </span>
      </ElTooltip>
      <Button v-else :label="buttonLabel" :disabled="disabled" @clicked="$emit('click')" />
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconLock from '@/components/icons/IconLock.vue'
import { ElTooltip } from 'element-plus'

export default {
  name: 'CtaBox',
  components: {
    Button,
    IconChevronRight,
    IconLock,
    ElTooltip,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
      default: 'Termin buchen',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledTooltip: {
      type: String,
      default: '',
    },
    /** variant with less vertical padding and no padding on mobile */
    slim: {
      type: Boolean,
      default: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss">
.cta-box {
  display: flex;
  justify-content: space-between;
  border: 1px solid $color-grey-light;
  border-radius: 4px;
  padding: 24px;
  width: 100%;
  background: transparent;
  text-align: left;

  + .cta-box {
    margin-top: 16px;
  }

  @media (max-width: $breakpoint-max-mobile) {
    padding: 16px;
  }

  &--clickable {
    cursor: pointer;
    &:hover {
      background-color: rgba($color-grey-light, 0.3);
    }
  }

  &--slim {
    padding-block: 12px;

    @media (max-width: $breakpoint-max-mobile) {
      padding: 0;
      border-width: 0;
    }

    .cta-box__right {
      @media (max-width: $breakpoint-max-mobile) {
        flex-wrap: nowrap;
        column-gap: 4px;
      }
    }
  }

  &__icon {
    @include flex-center;
    flex: 0 0 56px;
    background-color: $color-yellow-primary;
    border-radius: 50%;
    margin-right: 24px;
    height: 56px;

    @media (max-width: $breakpoint-max-mobile) {
      flex: 0 0 40px;
      margin-right: 16px;
      height: 40px;

      :deep(svg) {
        height: 24px;
        width: 24px;
      }
    }

    &--disabled {
      background-color: $color-grey-light;
    }
  }

  &__right {
    @include flex-center-align;
    justify-content: space-between;
    width: 100%;

    &--wrapped {
      flex-wrap: wrap;
      row-gap: 16px;
    }
  }

  &__text {
    width: fit-content;

    p:first-of-type {
      font-weight: $font-weight-medium;
    }

    p:last-of-type {
      color: $color-text-secondary;
    }
  }
}
</style>
